import {useCallback} from 'react'

import {ViewTypeParam} from '../../api/view/contracts'
import {ViewStateActionTypes} from '../../hooks/use-view-state-reducer/view-state-action-types'
import {useViews} from '../../hooks/use-views'

type UseAgentAssignmentVisibility = {
  /** Whether or not the table should show agent assignment tasks */
  agentAssignmentVisible: boolean
  /** Set the agent assignment visibility state */
  setAgentAssignmentVisible: (viewNumber: number, visible: boolean) => void
}

export const useAgentAssignmentVisibility = (): UseAgentAssignmentVisibility => {
  const {currentView, viewStateDispatch} = useViews()

  const visible =
    currentView?.localViewState?.layout === ViewTypeParam.Table &&
    (currentView?.localViewState?.layoutSettings?.table?.agentAssignment?.visible ?? true)

  const setVisible = useCallback(
    (viewNumber: number, newVisible: boolean): void => {
      viewStateDispatch({
        type: ViewStateActionTypes.SetAgentAssignmentVisible,
        viewNumber,
        visible: newVisible,
      })
    },
    [viewStateDispatch],
  )

  return {
    agentAssignmentVisible: visible,
    setAgentAssignmentVisible: setVisible,
  }
}
